import { FC, ReactNode } from "react";
import { styled } from "@mui/material";
import Typography from "@mui/material/Typography";
import Container from "@mui/material/Container";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import LinearProgress from "@mui/material/LinearProgress";

type Props = {
  title?: string;
  children?: ReactNode;
  maxWidthCard?: number;
  maxWidthContainer: any;
  linearProgress?: boolean;
};

const TableLayout: FC<Props> = ({ title, children, linearProgress, maxWidthContainer, maxWidthCard }) => {
  return (
    <Container maxWidth={maxWidthContainer} sx={{ paddingBottom: "1rem" }}>
      <Card sx={{ maxWidth: maxWidthCard }}>
        {linearProgress && <LinearProgress />}
        {title && (
          <Title>
            <TypographyStyled variant='h5' align='center'>
              {title}
            </TypographyStyled>
          </Title>
        )}
        <ContainerStyled maxWidth='xl'>{children}</ContainerStyled>
      </Card>
    </Container>
  );
};

export default TableLayout;

const Title = styled("div")`
  padding-top: 2rem;
`;

const TypographyStyled = styled(Typography)`
  color: ${({ theme }) => theme.palette.text.primary};
`;

const ContainerStyled = styled(Container)`
  background-color: ${({ theme }) => theme.palette.background.default};
  min-height: 800px;
  padding: 1.7rem;
  margin: "auto";
`;
